export default __webpack_public_path__ + "static/media/stripe.c4fad064.png";